import React, { useEffect, useState } from 'react';
import WelcomeV3 from '@features/welcome/ui/components/WelcomeV3';
import Welcome from '@features/welcome/ui/components/Welcome';
import axios from 'axios';

import { isVariationV3Route, redirectToStore, setTheme } from '@shared/utils/general';
import { EVENT_NAMES, LogService } from '@shared/services/LogService';
import { ThemeContext } from '@shared/store/context/ThemeContext';
import { APP_THEMES } from '@shared/config/constants/app';
import { useCleanReferrerTillOTP } from '@shared/hooks';
import { reachedThankYouPage } from '@features/dcb-flow';
import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';
import { Helpers } from '@shared/utils/Helpers';
import { useQuery } from '@shared/hooks';
const WelcomeParent = ({ location }) => {
  const { query } = useQuery();
  const [isWhite, setIsWhite] = useState(false);
  const [isPaypal, setIsPaypal] = useState(false);

  const [activationURL, setActivationURL] = useState(null);

  useCleanReferrerTillOTP();

  const noRedirect = query.get('noRedirect') && query.get('noRedirect') === 'true';

  const dcb = useAtomValue(dcbAtom);
  const isV3Route = isVariationV3Route(dcb.variationKey);

  const theme = isV3Route ? APP_THEMES.BLUE : isWhite ? APP_THEMES.WHITE : APP_THEMES.BLACK;

  const handlePaypalSubscription = async (paypalCheckoutSessionId) => {
    //sandbox
    // const handleConfirmPaypalPaymentUrl = "http://localhost/api/paypal/subscribeUsingPaypal";

    //live
    const handleConfirmPaypalPaymentUrl =
      'https://prod-plus-api.360vuz.com/api/paypal/subscribeUsingPaypal';

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let formData = {
        checkoutSessionId: paypalCheckoutSessionId,
      };
      const res = await axios.post(handleConfirmPaypalPaymentUrl, formData, config);
      let resData = res.data;

      if (resData.errorCode === 0) {
        LogService.finishFlowPaypal({
          state: 'subscriber',
          subscriberId: resData.data?.subscriberId,
        });

        if (resData.data && resData.data.activationURL) {
          LogService.redirectToApp({}, resData.data.activationURL);

          if (!noRedirect) {
            setActivationURL(resData.data.activationURL);

            setTimeout(() => {
              window.location = resData.data.activationURL;
            }, 500);
          }
        } else {
          if (!noRedirect) {
            setTimeout(() => {
              redirectToStore();
              setIsPaypal(false);
            }, 1500);
          }
        }
      } else {
        LogService.handleEvent(EVENT_NAMES.cc_failed_flow_paypal);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleThreeDsSubscription = async (threeDsCheckoutSessionId) => {
    //sandbox
    // const handleConfirm3dsPaymentUrl = 'http://localhost/api/cc/handle3dSecurePayment';

    //live
    const handleConfirm3dsPaymentUrl =
      'https://prod-plus-api.360vuz.com/api/cc/handle3dSecurePayment';

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let formData = {
        checkoutSessionId: threeDsCheckoutSessionId,
      };
      const res = await axios.post(handleConfirm3dsPaymentUrl, formData, config);
      let resData = res.data;
      if (resData.errorCode === 0) {
        if (resData.data && resData.data.activationURL) {
          LogService.redirectToApp(
            {
              state: 'subscriber',
              subscriberId: resData.data?.subscriberId,
            },
            resData.data.activationURL
          );

          setActivationURL(resData.data.activationURL);

          if (!noRedirect) {
            setTimeout(() => {
              window.location = resData.data.activationURL;
            }, 500);
          }
        } else {
          if (!noRedirect) {
            setTimeout(() => {
              redirectToStore();
              setIsPaypal(false);
            }, 1500);
          }
        }
      } else {
        console.error('error in 3ds payment');
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCheck = async (checkoutId) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      let formData = {
        checkoutSessionId: checkoutId,
      };

      // const threeDsLinkCheck = 'http://localhost/api/cc/handleCheckPaypalOr3ds';
      const threeDsLinkCheck = 'https://prod-plus-api.360vuz.com/api/cc/handleCheckPaypalOr3ds';

      const res1 = await axios.post(threeDsLinkCheck, formData, config);
      const checkData = res1.data;

      if (checkData && checkData.source) {
        if (checkData.source === 'threeDs') {
          handleThreeDsSubscription(checkoutId);
        } else if (checkData.source === 'paypal') {
          handlePaypalSubscription(checkoutId);
        }
      }
    } catch (err) {}
  };

  useEffect(() => {
    reachedThankYouPage();

    if (location && location.state && location.state.isWhite && location.state.isWhite === true) {
      setTheme(APP_THEMES.WHITE);
      setIsWhite(true);
    }

    let paypalCheckoutSessionId = Helpers.getUrlParameter('cko-session-id') || '';
    if (paypalCheckoutSessionId) {
      setIsPaypal(true);

      handleCheck(paypalCheckoutSessionId);
    } else {
      if (location && location.state && location.state.activationURL) {
        setActivationURL(location.state.activationURL);
        if (window.location.href.includes('thankyou')) {
          LogService.dcbRedirectToApp(location.state.activationURL);
        } else {
          LogService.redirectToApp({ state: 'subscriber' }, location.state.activationURL);
        }

        if (!noRedirect) {
          setTimeout(() => {
            window.location = location.state.activationURL;
          }, 7000);
        }
      } else {
        if (!noRedirect) {
          setTimeout(() => {
            redirectToStore();
          }, 7000);
        }
      }
    }
  }, [noRedirect]);

  return (
    <ThemeContext.Provider value={{ theme }}>
      {isV3Route ? (
        <WelcomeV3 activationURL={activationURL} />
      ) : (
        <Welcome activationURL={activationURL} isPaypal={isPaypal} />
      )}
    </ThemeContext.Provider>
  );
};

export { WelcomeParent };
